import { AlertService } from 'src/app/shared/toast/alert.service';
import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomLoadingService } from 'src/app/shared/custom-loading/custom-loading.service';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { DocumentViewService } from '../document-view.service';
declare var myExtObject: any;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  @Input() attachmentId: string;
  @Input() attachmentType: string;
  public attachmentData: any;
  public fileExtension: any;
  emailSent: boolean = false;
  //public _attachmentData: any;


  public title: string = "Documents";

  public UserEmailaddress: string;
  public DocumentViewForm: FormGroup;
  public isReadOnly: boolean = true;
  public showHistoryButton: boolean = true;
  public isPdfDocument: boolean = false;

  public status: any;
  public isViewNotSupported: boolean = false;
  constructor(
    private elementRef: ElementRef,
    private activatedRoute: ActivatedRoute,
    public documentViewService: DocumentViewService,
    public customLoadingService: CustomLoadingService,
    private domSanitizer: DomSanitizer,
    private appSettingService: AppSettingService,
    private fb: FormBuilder,
    private router: Router,
    private toastService: AlertService
  ) {

    activatedRoute.params.subscribe(params => {

      this.attachmentType = params["type"];
      this.attachmentId = params["id"];
      
    });

    this.DocumentViewForm = fb.group({
      'EmailAddress': [this.appSettingService.loggedInUser.EmailAddress,
         Validators.compose([Validators.required, Validators.maxLength(256),Validators.email])],
      'Id': [this.attachmentId],
      'Type': [this.attachmentType]
    });
  }

  ngOnInit() {
    try {

      this.getDocumentData(parseInt(this.attachmentType), this.attachmentId);

    } catch (error) {

    }
  }


  getBinnaryData(): any {
    return this.attachmentData;
  }

  getDocumentData(type: number, id: string) {
    try {
      if (id != "") {
        this.customLoadingService.show(type);

        this.documentViewService.getDocumentData(type, id)
          .subscribe(res => {

            if (res) {

              if (res.Attachment == null) {
                window.history.back();
              }

              this.DocumentViewForm.get("Id").setValue(res.Id);
              this.fileExtension = res.FileExtension;


              if (this.fileExtension == '.pdf') {

                var dataUriBinary = this.convertDataURIToBinary(res.Attachment)
                var blob = new Blob([dataUriBinary], { type: "application/pdf" });
                var url = URL.createObjectURL(blob);

                this.isPdfDocument = true;
                if (type == 7) {
                  myExtObject.intializePdfJs(url, res.FileName);
                }
                else {
                  myExtObject.intializePdfJs(url, "");
                }

              }
              else if (this.fileExtension == '.png' || this.fileExtension == '.jpg' || this.fileExtension == '.jpeg') {
                this.attachmentData = this.domSanitizer.bypassSecurityTrustResourceUrl(res.Attachment);
              }
              else {

                this.isViewNotSupported = true;
                let attachmentArr = res.Attachment.toString().split(',');
                let contentType = attachmentArr[0].toString().replace("data:").replace(";base64")
                let base64Data = attachmentArr[1].toString();
                const myBlob = this.base64ToBlob(base64Data, contentType);
                this.downloadFile(myBlob, res.FileName);
              }
            }
          }, (err) => {
            if (err.status === 500) {

              let validationErrorDictionary = JSON.parse(err.text());
              //   this.status = validationErrorDictionary.ModelState["Status"]
              this.toastService.success("Internal server error.", { keepAfterRouteChange: false });
            }

            if (err.status === 400) {

              let validationErrorDictionary = JSON.parse(err.text());
              this.status = validationErrorDictionary.ModelState["Status"];

              if (this.status == 500) {
                this.customLoadingService.hide(type);
                this.toastService.success("Internal server error.", { keepAfterRouteChange: false });
      
               
              }

            } else {
              this.status = 101;

            }
            this.customLoadingService.hide(type);
          }, () => {

            this.customLoadingService.hide(type);
          });
      }
      else {
        window.history.back();
      }

    } catch (error) {
      throw Error(error);
    }
  }



  base64ToBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  downloadFile(myBlob: Blob, myFileName: string): void {
    const blob: Blob = myBlob;
    const fileName: string = myFileName;
    const objectUrl: string = URL.createObjectURL(blob);
    const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
    a.href = objectUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(objectUrl);
  }


  BASE64_MARKER = ';base64,';

  convertDataURIToBinary(dataURI) {
    var base64Index = dataURI.indexOf(this.BASE64_MARKER) + this.BASE64_MARKER.length;
    var base64 = dataURI.substring(base64Index);
    var raw = window.atob(base64);
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));

    for (var i = 0; i < rawLength; i++) {
      array[i] = raw.charCodeAt(i);
    }
    return array;
  }
  closeDocument() {
    try {
      window.history.back();
    } catch (error) {

    }
  }
  openDialog() {

    this.emailSent = false;
  }
  printDocument() {
    try {
      if (this.fileExtension == '.pdf') {
        myExtObject.printPdf();
      }
    } catch (error) {
      throw Error(error);
    }
  }

  changeEmailAddress() {
    this.isReadOnly = (this.isReadOnly === true) ? false : true;
  }

  
  

  submitForm(model: any, isValid: boolean) {
    try {
      if (isValid) {
        model.FullName = this.appSettingService.loggedInUser.FirstName + ' ' + this.appSettingService.loggedInUser.LastName;
        this.customLoadingService.show();

        this.documentViewService.emailAttachment(model)
          .subscribe(res => {
           
            this.emailSent = true;
            this.customLoadingService.hide();
          },
            error => {
              this.emailSent = false;
              // this.toastService.activate("Problem sending Attachments");

              this.customLoadingService.hide();
            },
            () => {
              //  $("#email-document").modal("hide");

              this.customLoadingService.hide();
            });
      }
    } catch (error) {
      this.customLoadingService.hide();
    }

  }

  dataimage() {

    return this.attachmentData;
  }
  testing() {
    return true;
    // alert("Hola");
  }
}
